<template>
  <div>
    <h2>Configure Parameter</h2>
    <div class="alert alert-info" v-if='loading'>
      <img src='/static/drip.svg' />Loading data...</div>
    <div v-else>
      <div class="form-group">
        <label>Parameter</label>
        <select class="form-control" v-model='selected' @change='getValue'>
          <option v-for='p in parameters' :value='p' :key='p'>{{p.ParameterName}}</option>
        </select>
      </div>
      <div class="form-group">
        <label>Number of Decimal Places</label>
        <input class="form-control" type='text' v-model='selected.NumberOfDecimalPoint' />
      </div>
      <div class="form-group">
        <button class="btn btn-primary" @click='save'>Save</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        parameters: [],
        selected: {},
        loading: true,
      }
    },
    methods: {
      getValue() {
        this.axios.get(`/api/AdminAPI/GetDataTypeConfiguration?dataTypeName=${this.selected.ParameterName}`).then((res) => {
          this.$set(this.selected, 'NumberOfDecimalPoint', res.data.NumberOfDecimalPoint)
        })
      },
      save() {
        this.axios.post('/api/AdminAPI/SaveBatchConfig', this.selected).then(() => {
          this.success('Parameter Updated')
        })
      },
    },
    mounted() {
      this.axios.get('/api/AdminAPI/GetAquariusParameters').then(res => {
        this.parameters = res.data.map(p => { return { ParameterName: p, NumberOfDecimalPoint: null } })
        this.loading = false
      })
    },
  }
</script>

<style scoped>
  tbody tr {
    cursor: pointer;
  }

  tbody:hover tr:hover {
    background: #eee;
  }
</style>
